import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { cartService, catalogService } from "../services";

const buildMenu = (games, mobiles, cards) => [
  { label: "หน้าหลัก", to: "/" },
  {
    label: "เติมเกม",
    to: "/topup/game",
    children: [
      { label: "ดูเกมทั้งหมด", to: "/topup/game" },
      ...games.slice(0, 8).map((game) => ({ label: game.name, to: `/topup/game/${game.id}/${game.slug}` })),
    ],
  },
  {
    label: "เติมเงินมือถือ",
    to: "/topup/mobile",
    children: [
      { label: "ดูทั้งหมด", to: "/topup/mobile" },
      ...mobiles.map((item) => ({ label: item.name, to: `/topup/mobile/${item.id}/${item.slug}` })),
    ],
  },
  {
    label: "บัตรเติมเงิน",
    to: "/topup/card",
    children: [
      { label: "ดูทั้งหมด", to: "/topup/card" },
      ...cards.map((item) => ({ label: item.name, to: `/topup/card/${item.id}/${item.slug}` })),
    ],
  },
  { label: "โปรโมชั่น", to: "/promotions" },
  { label: "เกี่ยวกับ", to: "/about" },
];

export default function MainNavbar({ profile, onLogout }) {
  const location = useLocation();
  const [menu, setMenu] = useState(buildMenu([], [], []));
  const [openKey, setOpenKey] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [cartCount, setCartCount] = useState(cartService.count());
  const navRef = useRef(null);

  useEffect(() => {
    const sync = () => setCartCount(cartService.count());
    window.addEventListener("lt-cart-change", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("lt-cart-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  useEffect(() => {
    let alive = true;
    Promise.all([catalogService.games(), catalogService.mobileOperators(), catalogService.cards()]).then(
      ([games, mobiles, cards]) => {
        if (alive) setMenu(buildMenu(games || [], mobiles || [], cards || []));
      }
    );
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    setOpenKey(null);
    setMobileOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) setOpenKey(null);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const isActive = (to) => (to === "/" ? location.pathname === "/" : location.pathname.startsWith(to));

  return (
    <>
      <nav className="lt-navbar">
        <div className="lucid-container lt-navbar__inner">
          <Link to="/" className="lt-brand">
            <span className="lt-brand__mark">LT</span>
            <span className="lt-brand__text">
              LucidTopup
              <span>Top-up game</span>
            </span>
          </Link>

          <div className="lt-nav" ref={navRef}>
            {menu.map((item) =>
              item.children ? (
                <div className="lt-nav__item" key={item.label}>
                  <button
                    type="button"
                    className={`lt-nav__link ${isActive(item.to) ? "is-active" : ""}`}
                    onClick={() => setOpenKey(openKey === item.label ? null : item.label)}
                  >
                    {item.label}
                    <span className="lt-nav__caret">▼</span>
                  </button>
                  {openKey === item.label ? (
                    <div className="lt-nav__dropdown">
                      {item.children.map((child) => (
                        <Link key={child.to + child.label} to={child.to}>
                          {child.label}
                        </Link>
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : (
                <Link key={item.to} to={item.to} className={`lt-nav__link ${isActive(item.to) ? "is-active" : ""}`}>
                  {item.label}
                </Link>
              )
            )}
          </div>

          <Link to="/cart" className="lt-cart-link" aria-label={`ตะกร้า ${cartCount} รายการ`} title="ตะกร้า">
            <span aria-hidden="true">🛒</span>
            {cartCount > 0 ? <span className="lt-cart-link__badge">{cartCount > 99 ? "99+" : cartCount}</span> : null}
          </Link>

          <button type="button" className="lt-navbar__toggle" onClick={() => setMobileOpen((v) => !v)}>
            {mobileOpen ? "✕" : "☰"}
          </button>
        </div>
      </nav>

      {mobileOpen ? (
        <div className="lt-mobile-menu">
          {menu.map((item) => (
            <div key={item.label}>
              <Link to={item.to}>{item.label}</Link>
              {item.children ? (
                <>
                  <div className="lt-mobile-menu__group">{item.label}</div>
                  {item.children.slice(0, 6).map((child) => (
                    <Link key={child.to + child.label} to={child.to} style={{ fontSize: 14, opacity: 0.85 }}>
                      {child.label}
                    </Link>
                  ))}
                </>
              ) : null}
            </div>
          ))}
          <div className="lt-mobile-menu__group">บัญชีของฉัน</div>
          {profile ? (
            <>
              <Link to="/profile">โปรไฟล์ของฉัน</Link>
              <button type="button" onClick={onLogout} style={{ color: "var(--lt-red)" }}>
                ออกจากระบบ
              </button>
            </>
          ) : (
            <>
              <Link to="/login">เข้าสู่ระบบ</Link>
              <Link to="/register">สมัครสมาชิก</Link>
            </>
          )}
        </div>
      ) : null}
    </>
  );
}
